<template>
  <div class="">
    <Landing :landingData="landingData" />
    <AboutInstructor id="about" :instructorData="instructorData" />
    <ProgramInfo id="program" :info="programData" />
    <BasicRequirement :info="basicRequirement" />
    <PositionSummary :info="positionInfo" />
    <TestimonialCompany :info="companyTestimonial" style="padding-top:40px" />
    <Faq id="faq" :info="faq" />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>
<script>
import AboutInstructor from '../../components/AssessmentIsa/AboutTheCompany.vue'
import TestimonialCompany from '../../components/AssessmentIsa/CompanyTestimonial.vue'
import Landing from '../../components/AssessmentIsa/LandingAssessment.vue'
import ProgramInfo from '../../components/AssessmentIsa/ProgramInfo.vue'
import Contact from '../../components/isaMain/Contact.vue'
import PositionSummary from '../../components/AssessmentIsa/PositionSummary.vue'
import BasicRequirement from '../../components/AssessmentIsa/BasicReq.vue'
import Faq from '../../components/shera/Faq.vue'

export default {
  data() {
    return {
      landingData: {
        title1: 'Work as a Golang DEVELOPER',
        //   subTitle: 'Senior Marketing Executive (Contractual)',
        paragraph:
          'Take the assessment curated by Upskill and get a chance to work at Shikho, as a Golang developer. salary  125, 000 - 250,000 BDT',
        companyLogo: '',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/2363e3f0-3492-4c10-96cb-bdd3bc1ba33b?public=true&job=GolangEngineer',
        landingImage: require('../../assets/AssementLanding/Group 1200.png'),
        spanColor: 'grey',
      },
      instructorData: {
        //   name: 'Fayaz Taher',
        avatar: require('../../assets/AssementLanding/Company_Logo/Screenshot_2022-03-22_050844-removebg-preview.png'),
        info:
          'Shikho is a Bangladeshi education technology start-up with a mission to democratize access to high-quality education. It has recently raised $1.6m USD of investment and is backed by several global top tier investors, including Silicon Valley based EdTech global investment specialists Learn Capital, New York based venture capital firm Anchorless Bangladesh, Singapore based venture capital firm Wavemaker Partners, as well as the Founder and CEO of American EdTech, Teachable. Shikho aims to build a holistic learning ecosystem for a digitally enabled Bangladeshi student population, across primary, secondary, and tertiary education.',
        designation: '',

        //   bgColor: '#DDEAFA',
        bgColor: 'white',
        txtColor: '#29292B',
      },
      programData: {
        headingInfo:
          'The assessment consists of 15 MCQS. You are required to pass the assessment test with a minimum of 60% of the total score. Top 5-10 Candidates will get the chance to go to the interview round after completing the assessment.',
        seatsInfo: '',
        startDate: '22nd March ',
        cost: 'Free',
        deadline: '8th April',

        bgColor: '#1EBCE5',
        txtColor: '#5277F7',
      },
      positionInfo: {
        //   paragraph:
        //     'This role is within the department Bongo Studios (www.bongostudios.com), which is the fastest-growing vertical within Bongo. Bongo Studios is a Multi-Channel Network (MCN) of a community of creative and independent content producers from multiple countries. We nurture talent and optimize content for our creators to help them achieve enhanced growth and monetization on multiple platforms (YouTube, Facebook, BongoBD, etc.). Currently, our creators reach over 180 million subscribers and have over 1.5 billion views per month.For this job role, we are looking for someone who is PMP certified and hassuccessfully managed a large team for at least 3 years, at a well-recognized company.The ideal candidate will be responsible for planning, coordinating, and managing the team within the timeline, budget, scope, and targets set for the department. They will also effectively monitor and present the updates to relevant stakeholders, clients, and team members.',
        //   remote: '',
        //   jobType: 'Job Type: Full-time ',
        //   txtColor: '#5277F7',
      },
      companyTestimonial: {
        //   mainImg: require('../assets/bongo/CTO_Bongo_Shadid 1.png'),
        //   name: 'Shadid Haque',
        //   paragraph:
        //     'At Bongo we believe in human-centric designs because people ignore design that ignores people. We are very excited to team up with Upskill in our mission to recruit the very best talents from all walks of life. We welcome anyone who wants to solve problems that impact millions of users and be part of a team that is empowered to do so.',
        //   designation: 'CTO  of Bongo',
        //   imgBg: '#DDEAFA',
        //   invertedCommaBg: '',
        //   firstComma: require('../assets/Canadian Tech company/“.svg'),
        //   secondComma: require('../assets/Canadian Tech company/Group 22.svg'),
      },
      basicRequirement: {
        mainContent: [
          'Can demonstrate experience building',
          'A minimum of 2 to 3 years of experience in production level Golang based software development',
          'A good understanding in Database modelling;',
          'Have worked with NoSQL Database before and have a firm understanding of document modelling',
          'Deep understanding and knowledge of test-driven API development principles',
          'Should have working experience in building API with Golang',
          'Thorough understanding of REST-ful API design',
          'Basic understanding of GraphQL API',
          'Experience writing clean, maintainable, easy-to-test code with Golang',
          'Test Driven Development (TDD) experience',
          'Familiar with GitHub source control and Continuous Integration',
          'Experience in analysing requirements and turning it into a solution',
          'Experience in collaborating with product owners using an agile process',
          'Experience in Graph Database is a plus.',
        ],
        bgColor: '#184DBD',
      },

      outlineColor: {
        color: '#EA4424',
      },

      faq: [
        {
          title: 'What is the duration of the assessment? \n',
          content: '10 minutes. \n',
          category: 'FAQ',
        },
        {
          title: 'What is the assessment  fee? \n',
          content: 'It is free',
          category: 'FAQ',
        },
        {
          title: 'Do you need previous work experience? \n',
          content: 'Yes, 4 years on backend developer\n',
          category: 'FAQ',
        },
        {
          title: 'How much do I need to secure to qualify?\n',
          content: '60% of the total score i.e. 6 out of 10',
          category: 'FAQ',
        },

        {
          title: 'How many times can I take the quiz?\n',
          content:
            'You can take the quiz twice. The highest score will be counted as the final score.\n',
          category: 'FAQ',
        },
        //   {
        //     title: 'Will all the top 5 students get a job at Bongo?\n',
        //     content:
        //       'No, the top 5 students will get a chance to interview at Bongo, and will get the job depending on their performance in the interview.\n',
        //     category: 'FAQ',
        //   },
        {
          title: 'Salary?\n',
          content: '125k-250k  \n',
          category: 'FAQ',
        },
      ],
    }
  },
  components: {
    Landing,
    AboutInstructor,
    Faq,
    ProgramInfo,
    Contact,
    TestimonialCompany,
    BasicRequirement,
    PositionSummary,
  },
  created() {
    this.Loaded()
  },
}
</script>
